import React, { FC, useEffect, useState } from "react";
import { Modal } from "@shared/components/Modal";
import { ButtonPrimary, ButtonSecondary, InputPicker } from "@shared/components";
import { useDispatch, useSelector } from "react-redux";
import "./index.scss";
import { Account, User } from "@shared/models";
import { useDebounce } from "@shared/hooks";
import { actions as AccountActions, selectors as AccountSelectors } from "@containers/Account/store";
import { moveUserToAnotherCompany } from "@containers/Account/store/actions";
import { showNotification } from "@shared/store/actions";
import * as sharedActions from "@shared/store/actions";

interface ModalMoveUserToAnotherCompanyProps {
  onClose: () => void;
  data?: {
    user: User;
    account: Account;
    onCloseForm: () => void;
  };
}

export const ModalMoveUserToAnotherCompany: FC<ModalMoveUserToAnotherCompanyProps> = ({ onClose, data }) => {
  const [search, setSearch] = useState("");
  const [accountId, setAccountId] = useState<number | null>(null);

  const debounceSearch = useDebounce(search || "", 500);

  const dispatch = useDispatch();

  const accounts = useSelector(AccountSelectors.getAccountsList());

  useEffect(() => {
    dispatch(sharedActions.updateOverlay({ leaveConfirm: false }));
  }, [dispatch]);

  const move = () =>
    data?.user?.id &&
    accountId &&
    dispatch(sharedActions.hideModal()) &&
    dispatch(
      moveUserToAnotherCompany.request({
        accountId,
        oldAccountId: data.account.id,
        userId: data.user.id,
        callback: () => {
          dispatch(
            showNotification({
              message: `User ${data?.user?.first_name} ${data?.user?.last_name} successfully moved to ${
                accounts?.list?.find((a) => a.id === accountId)?.name
              }.`,
              appearance: "success",
            }),
          );

          dispatch(AccountActions.getAccount.request({ id: Number(data.account.id) }));
          data?.onCloseForm?.();
        },
      }),
    );

  useEffect(() => {
    dispatch(AccountActions.getAccountsList.request({ search: debounceSearch, page: 1, limit: 10 }));
  }, [dispatch, debounceSearch]);

  return (
    <div className="modal-move-user-to-another-company">
      <Modal.Section>
        <Modal.Title>
          Move &quot;{data?.user?.first_name} {data?.user?.last_name}&quot; to Other Company
        </Modal.Title>
        <Modal.Content>
          <div className="small-text">Please select the company to which you would like to move this user.</div>

          <InputPicker
            searchable
            cleanable={false}
            name="companyId"
            className="select-picker"
            placeholder="Enter Company Name"
            useContainer
            disableContainerStyles
            value={accountId}
            data={(accounts?.list || []).map((a) => ({ value: a.id, label: a.name }))}
            onChange={setAccountId}
            onSearch={setSearch}
          />
        </Modal.Content>
        <Modal.Actions>
          <ButtonSecondary onClick={onClose}>Cancel</ButtonSecondary>
          <ButtonPrimary type="submit" onClick={move} disabled={!data?.user?.id || !accountId}>
            Move User
          </ButtonPrimary>
        </Modal.Actions>
      </Modal.Section>
    </div>
  );
};
